import React, {memo, useCallback, useMemo} from 'react'
import {
    TimeLineContentHeaderWrapper,
    TimeLineContentWrapper
} from '../../../styles/styles'
import {ActivityAvito} from "../../../types/types";
import TimelineItemHeaderText from "../activity-timeline-item-header-text/activity-timeline-item-header-text";
import TimelineItemHeader from "../activity-timeline-item-header/activity-timeline-item-header";
import {useFormatDate} from "../../../hooks/useFormatDate";
import {TimelineItemProps} from "../activity-timeline-Item";


type ActivityTimelineAvitoType = Omit<TimelineItemProps, 'data'>

interface ActivityTimelineAvitoProps extends ActivityTimelineAvitoType {
    className?: string;
    data?: ActivityAvito
}


const ActivityTimelineAvito: React.FC<ActivityTimelineAvitoProps> = memo((props: ActivityTimelineAvitoProps) => {
    const {date, user, data} = props;

    const getBgColor = useCallback(() => {
        if (data?.avitoType === 'avito-note') {
            if (data?.direction === 'Менеджер')
                return '#cfffcc'
            return '#ccd7ff'
        }
        return ''
    }, [data])

    const bgColor = getBgColor()

    const formatDate = useMemo<string>(
        () => useFormatDate(date),
        [date],
    );

    return (
        <TimeLineContentWrapper color={bgColor}>
            <TimeLineContentHeaderWrapper>
                {
                    (data?.avitoType !== 'avito-top')
                        ? <TimelineItemHeader title={data?.title} date={date}/>
                        : <TimelineItemHeaderText title={data?.title}/>
                }
            </TimeLineContentHeaderWrapper>
            <>
                {
                    data?.avitoType === 'avito-top'
                        ?
                        (
                            <>
                                <div><p><b> {formatDate}</b></p></div>
                                <div>
                                    {data?.content?.split('\n')?.map((line, index) => (<div key={index}>{line}</div>))}
                                </div>
                            </>
                        )
                        :
                        (
                            <div>
                                {user?.name}: {data?.content}
                            </div>
                        )
                }
            </>
        </TimeLineContentWrapper>
    )
})

export default ActivityTimelineAvito
